/**
 * useWorkspaceImages Hook
 * 
 * Lädt Workspace-Bilder mit Pagination.
 */

import { useQuery } from '@tanstack/react-query';
import { getWorkspaceImages } from '@/lib/api/workspace';
import type { Image, ImagePagination } from '@/types';

interface UseWorkspaceImagesOptions {
  page?: number;
  perPage?: number;
  enabled?: boolean;
}

export function useWorkspaceImages(options: UseWorkspaceImagesOptions = {}) {
  const { page = 1, perPage = 12, enabled = true } = options;

  const query = useQuery({
    queryKey: ['workspace', 'images', { page, perPage }],
    queryFn: () => getWorkspaceImages(page, perPage),
    enabled,
    staleTime: 30 * 1000, // 30 Sekunden
  });

  return {
    images: query.data?.images as Image[] | undefined,
    pagination: query.data?.pagination as ImagePagination | undefined,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
  };
}

export default useWorkspaceImages;


